
export interface CreateTweetResponse {
  /** ID of the created tweet */
  tweetId: string;
}
